import Vue from "vue";
import Router from "vue-router";
import { authGuard } from "@/auth";
// Containers
const TheContainer = () => import("@/containers/TheContainer");

// Views
//const Portfolio = () => import('@/views/portfolio/Portfolio');
const Portfolio = () => import("@/views/portfolio/Portfolio");
const List = () => import("@/views/portfolio/List");
const Dashboard = () => import("@/views/new_dashboard/Dashboard");
const DashboardWrapper = () => import("@/views/new_dashboard/DashboardWrapper");
const ChangeCompany = () => import("@/components/ChangeCompany");
const ProjectReport = () => import("@/views/projectReport/projectReport");
const Register = () => import("@/views/pages/Register");
const ProjectReportWrapper = () =>
  import("@/views/projectReport/ProjectReportWrapper");
const APIDoc = () => import("@/views/api_doc/APIDoc");
const ChannelVerificationPage = () =>
  import("@/views/new_dashboard/project/ChannelVerificationPage");
const Home = () => import("@/views/home/Home");
const HomeDashboard = () => import("@/views/home/HomeDashboard");
const ListWrapper = () =>
  import("@/views/home/homeDashboard/lists/ListWrapper");
const MarketList = () =>
  import("@/views/home/homeDashboard/lists/market/MarketList");
const ChannelsList = () =>
  import("@/views/home/homeDashboard/lists/channels/ChannelsList");
const AffiliateList = () => import("@/views/home/homeDashboard/lists/affiliates/AffiliateList");
const MarketWrapper = () =>
  import("@/views/home/homeDashboard/lists/market/MarketWrapper");
const ChannelsWrapper = () =>
  import("@/views/home/homeDashboard/lists/channels/ChannelsWrapper");
const AffiliatesWrapper = () =>
  import("@/views/home/homeDashboard/lists/affiliates/AffiliatesWrapper");
const Events = () => import("@/views/home/events/Events.vue");
const EventListWrapper = () =>
  import("@/views/home/events/EventListWrapper.vue");
const Deliverables = () => import("@/views/projectReport/Deliverables");
const DeliverablesHome = () => import("@/views/projectReport/DeliverablesHome");
const SLAUptimeReport = () => import("@/views/projectReport/SLAUptimeReport");
const ChannelDetails = () =>
  import("@/views/new_dashboard/channelDetails/ChannelDetails");
const AffiliateDetails = () =>
  import("@/views/new_dashboard/affiliateDetails/AffiliateDetails");
const ChannelVerification = () =>
  import("@/views/new_dashboard/project/ChannelVerification");
const EventDetails = () =>
  import("@/views/home/events/eventDetails/EventDetails");
const EventDetailsWrapper = () =>
  import("@/views/home/events/eventDetails/EventDetailsWrapper");
const RequestChannelsContainerModal = () =>
  import("@/views/ChannelsRequest/RequestChannelsContainerModal");
const UnauthorizedAccess = () => import("@/views/pages/UnauthorizedAccess.vue")
const Page404 = () => import("@/views/pages/Page404.vue");
const SiteInactive = () => import("@/views/pages/SiteInactive.vue");
Vue.use(Router);

export default new Router({
  mode: "history", // https://router.vuejs.org/api/#mode
  linkActiveClass: "active",
  scrollBehavior: () => ({ y: 0 }),
  routes: configRoutes(),
});

function configRoutes() {
  return [
    {
      path: "/site-inactive",
      name: "SiteInactive",
      component: SiteInactive,
      beforeEnter: authGuard,
    },
    {
      path: "/",
      name: "",
      component: TheContainer,
      beforeEnter: authGuard,
      redirect: "/home",
      children: [
        {
          path: "/home",
          name: "Home",
          component: Home,
          redirect: "/home",
          children: [
            {
              path: "/home/channelVerification",
              name: "Home Channel Verification Wrapper",
              meta: { label: "Channel Verification" },
              redirect: "/home/channelVerification",
              component: ChannelVerification,
              children: [
                {
                  path: "/home/channelVerification",
                  name: "Home Channel Verification",
                  meta: { label: " " },
                  component: ChannelVerificationPage,
                },
                {
                  path: "/home/channelVerification/channeldetails/:instanceId",
                  name: "Home Channel Details",
                  meta: { label: "Channel Details" },
                  component: ChannelDetails,
                },
              ],
            },
            {
              path: "/home/events",
              name: "Home Events",
              meta: { label: "Events" },
              redirect: "/home/events",
              component: Events,
              children: [
                {
                  path: "/home/events",
                  name: "Home To Events",
                  meta: { label: " " },
                  component: EventListWrapper,
                },
                {
                  path: "/home/events/channeldetails/:instanceId",
                  name: "Home To Channel Details via events",
                  meta: { label: "Channel Details" },
                  component: ChannelDetails,
                },
                {
                  path: "/home/events/market-dashboard/:id/",
                  name: "Home Events To Dashboard Wrapper",
                  meta: { label: "Market Dashboard" },
                  component: DashboardWrapper,
                  redirect: "/home/events/market-dashboard/:id/",
                  children: [
                    {
                      path: "/home/events/market-dashboard/:id/",
                      component: Dashboard,
                      meta: { label: " " },
                      name: "Home Events To Dashboard",
                    },
                    {
                      path:
                        "/home/events/market-dashboard/:id/channeldetails/:instanceId",
                      component: ChannelDetails,
                      meta: { label: "Channel Details" },
                      name: "Home Events To Channel Details via Dashboard",
                    },
                  ],
                },
                {
                  path: "/home/events/event-details/:eventId",
                  name: "Event Details Wrapper",
                  component: EventDetails,
                  meta: { label: "Event Details" },
                  redirect: "/home/events/event-details/:eventId",
                  children: [
                    {
                      path: "/home/events/event-details/:eventId",
                      name: "Event Details",
                      meta: { label: " " },
                      component: EventDetailsWrapper,
                    },
                    {
                      path:
                        "/home/events/event-details/:eventId/channeldetails/:instanceId",
                      name: "Event Details To Channel Details",
                      meta: { label: "Channel Details" },
                      component: ChannelDetails,
                    },
                    {
                      path:
                        "/home/events/event-details/:eventId/market-dashboard/:id",
                      name: "Event Details To Dashboard Wrapper",
                      meta: { label: "Market Dashboard" },
                      component: DashboardWrapper,
                      redirect:
                        "/home/events/event-details/:eventId/market-dashboard/:id",
                      children: [
                        {
                          path:
                            "/home/events/event-details/:eventId/market-dashboard/:id",
                          meta: { label: " " },
                          name: "Event Details To Dashboard",
                          component: Dashboard,
                        },
                        {
                          path:
                            "/home/events/event-details/:eventId/market-dashboard/:id/channeldetails/:instanceId",
                          name:
                            "Event Details To Channel Details via Dashboard",
                          meta: { label: "Channel Details" },
                          component: ChannelDetails,
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            {
              path: "/home/channeldetails",
              name: "",
              meta: { label: "" },
              component: ChannelDetails,
              children: [
                {
                  path: "/home/channeldetails/:instanceId",
                  name: "Home TO Channel Details",
                  meta: { label: "Channel Details" },
                  component: ChannelDetails,
                },
              ],
            },
            {
              path: "/home/market-dashboard/:id",
              name: "Home TO Market Dashboard",
              meta: { label: "Market Dashboard" },
              component: Dashboard,
            },
            {
              path: "/home/channeldetails/:instanceId/market-dashboard/:id",
              name: "Home TO Channel Details TO Market Dashboard",
              meta: { label: "Market Dashboard" },
              component: Dashboard,
            },
            {
              path: "/home",
              name: "Home Dashboard Wrapper",
              component: Home,
              meta: { label: "Dashboard" },
              redirect: "/home/dashboard",
              children: [
                {
                  path: "/home/dashboard",
                  name: "Home Dashboard",
                  meta: { label: " " },
                  component: HomeDashboard,
                },
                {
                  path: "/home/dashboard/channel-request",
                  name: "Channel Request",
                  meta: { label: "Channel Request" },
                  component: RequestChannelsContainerModal,
                },
              ],
            },
            {
              path: "/home/list",
              name: "homelist",
              meta: { label: "List" },
              component: ListWrapper,
              redirect: "/home/list/market",
              children: [
                {
                  path: "/home/list/market",
                  name: "listmarket",
                  meta: { label: "Market" },
                  component: MarketList,
                },
                {
                  name: "MarketWrapper",
                  meta: { label: "Market" },
                  path: "/home/list/market",
                  redirect: "/home/list/market",
                  component: MarketWrapper,
                  children: [
                    {
                      name: "Market To Events",
                      meta: { label: "Events" },
                      path: "/home/list/market/events",
                      component: EventListWrapper,
                    },
                    {
                      name: "Market Events To Events Details",
                      meta: { label: "Event Details" },
                      path: "/home/list/market/event-details/:eventId",
                      component: EventDetailsWrapper,
                    },
                    {
                      name: "Market dashboard Wrapper",
                      meta: { label: "Dashboard" },
                      path: "/home/list/market-dashboard/:id",
                      component: DashboardWrapper,
                      redirect: "/home/list/market-dashboard/:id",
                      children: [
                        {
                          path: "/home/list/market-dashboard/:id",
                          name: "Market dashboard",
                          component: Dashboard,
                          meta: { label: " " },
                        },
                        {
                          name: "Market Dashboard to Channel Details",
                          meta: { label: "Channel Details" },
                          path:
                            "/home/list/market-dashboard/:id/channeldetails/:instanceId",
                          component: ChannelDetails,
                        },
                        {
                          name: "Market Dashboard Event to Event Details",
                          meta: { label: "Event Details" },
                          path:
                            "/home/list/market-dashboard/:id/event-details/:eventId",
                          component: EventDetailsWrapper,
                        },
                        {
                          name: "Market Dashboard to Events",
                          meta: { label: "Events" },
                          path: "/home/list/market-dashboard/:id/event/list",
                          component: EventListWrapper,
                        },
                        // {
                        //   name: 'Market Dashboard Event to Event Details',
                        //   meta: { label: 'Event Details' },
                        //   path: '/home/list/market-dashboard/:id/event/details/:eventId',
                        //   component: EventDetailsWrapper,
                        // },
                      ],
                    },
                  ],
                },
                {
                  path: "/home/list/channels",
                  name: "Channels List",
                  meta: { label: "Channels" },
                  component: ChannelsList,
                },
                {
                  name: "ChannelWrapper",
                  meta: { label: "Channels" },
                  path: "/home/list/channels",
                  redirect: "/home/list/channels",
                  component: ChannelsWrapper,
                  children: [
                    {
                      name: "Home Channels to Channel Details",
                      meta: { label: "Channel Details" },
                      path: "/home/list/channels/channeldetails/:instanceId",
                      component: ChannelDetails,
                    },
                    {
                      name: "Channel List to Events Details",
                      meta: { label: "Event Details" },
                      path: "/home/list/channels/event-details/:eventId",
                      component: EventDetailsWrapper,
                    },
                    {
                      name: "Home Channels to Market Dashboard Wrapper",
                      meta: { label: "Dashboard" },
                      path: "/home/list/channels/market-dashboard/:id",
                      component: DashboardWrapper,
                      redirect: "/home/list/channels/market-dashboard/:id",
                      children: [
                        {
                          path: "/home/list/channels/market-dashboard/:id",
                          name: "Home Channels to Market Dashboard",
                          meta: { label: " " },
                          component: Dashboard,
                        },
                        {
                          name: "Channels Dashboard to Events",
                          meta: { label: "Events" },
                          path:
                            "/home/list/channels/market-dashboard/:id/event/list",
                          component: EventListWrapper,
                        },
                        {
                          name: "Channels Dashboard to Event Details",
                          meta: { label: "Event Details" },
                          path:
                            "/home/list/channels/market-dashboard/:id/event/details/:eventId",
                          component: EventDetailsWrapper,
                        },
                        {
                          name: "Channels Dashboard Event to Event Details",
                          meta: { label: "Event Details" },
                          path:
                            "/home/list/channels/market-dashboard/:id/event/details/:eventId",
                          component: EventDetailsWrapper,
                        },
                        {
                          name: "Channels Dashboard to Channel Details",
                          meta: { label: "Channel Details" },
                          path:
                            "/home/list/channels/market-dashboard/:id/channeldetails/:instanceId",
                          component: ChannelDetails,
                        },
                      ],
                    },
                  ],
                },
                {
                  path: "/home/list/affiliates",
                  name: "Affiliates List",
                  meta: { label: "Affiliates" },
                  component: AffiliateList,
                },
                {
                  name: "AffiliatesWrapper",
                  meta: { label: "Affiliates" },
                  path: "/home/list/affiliate",
                  redirect: "/home/list/affiliates",
                  component: AffiliatesWrapper,
                  children: [
                    {
                      name: "Affiliate Details",
                      meta: { label: "Affiliate Details" },
                      path: "/home/list/affiliate/affiliatedetails/:AffiliateName",
                      component: AffiliateDetails,
                    },
                  ]
                }
              ],
            },
            {
              path: "/home/projectReport",
              name: "Home Project Report Wrapper",
              meta: { label: "Project Report" },
              component: ProjectReportWrapper,
              redirect: "/home/projectReport",
              children: [
                {
                  path: "/home/projectReport",
                  name: "Home Project Report",
                  meta: { label: " " },
                  component: ProjectReport,
                },
                {
                  path: "/home/projectReport/channelVerification",
                  name: "Home Project Report Channel Verification",
                  meta: { label: "Channel Verification" },
                  component: ChannelVerification,
                  redirect: "/home/projectReport/channelVerification",
                  children: [
                    {
                      path: "/home/projectReport/channelVerification",
                      name: "",
                      component: ChannelVerificationPage,
                    },
                    {
                      path:
                        "/home/projectReport/channelVerification/channeldetails/:instanceId",
                      name: "Home Project Report Channel Details",
                      meta: { label: "Channel Details" },
                      component: ChannelDetails,
                    },
                  ],
                },
              ],
            },
            {
              path: "/home/tam-report",
              name: "Home TAM Report Wrapper",
              meta: { label: "TAM Report" },
              component: ProjectReportWrapper,
              redirect: "/home/tam-report",
              children: [
                {
                  path: "/home/tam-report",
                  name: "Home TAM Report",
                  meta: { label: " " },
                  component: ProjectReport,
                },
                {
                  path: "/home/tam-report/channelVerification",
                  name: "Home TAM Report Channel Verification",
                  meta: { label: "Channel Verification" },
                  component: ChannelVerification,
                  redirect: "/home/tam-report/channelVerification",
                  children: [
                    {
                      path: "/home/tam-report/channelVerification",
                      name: "",
                      component: ChannelVerificationPage,
                    },
                    {
                      path:
                        "/home/tam-report/channelVerification/channeldetails/:instanceId",
                      name: "Home TAM Report Channel Details",
                      meta: { label: "Channel Details" },
                      component: ChannelDetails,
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          path: "/dashboard",
          name: "Lists ",
          component: List,
          redirect: "/portfolio",
          children: [
            {
              path: "/market-dashboard/:id",
              name: "Dashboard Wrapper",
              meta: { label: "Market Dashboard" },
              component: DashboardWrapper,
              redirect: "/market-dashboard/:id",
              children: [
                {
                  path: "/market-dashboard/:id",
                  name: "Dashboard",
                  meta: { label: " " },
                  component: Dashboard,
                },
                {
                  path: "/market-dashboard/:id/channelVerification",
                  redirect: "/market-dashboard/:id/channelVerification",
                  name: "Dashboard Channel Verification Wrapper",
                  meta: { label: "Channel Verification" },
                  component: ChannelVerification,
                  children: [
                    {
                      path: "/market-dashboard/:id/channelVerification",
                      name: "Dashboard Channel Verification",
                      component: ChannelVerificationPage,
                      meta: { label: " " },
                    },
                    {
                      path:
                        "/market-dashboard/:id/channelVerification/channeldetails/:instanceId",
                      name: "Dashboard Channel Verification Channel Details",
                      meta: { label: "Channel Details" },
                      component: ChannelDetails,
                    },
                  ],
                },
                {
                  path: "/market-dashboard/:id/events",
                  redirect: "/market-dashboard/:id/events",
                  name: "Dashboard TO Events Wrapper",
                  meta: { label: "Events" },
                  props: true,
                  component: Events,
                  children: [
                    {
                      path: "/market-dashboard/:id/events",
                      name: "Dashboard Events",
                      meta: { label: " " },
                      props: true,
                      component: EventListWrapper,
                    },
                    {
                      path:
                        "/market-dashboard/:id/events/event-details/:eventId",
                      name: "Dashboard Events To Event Details",
                      meta: { label: "Event Details" },
                      component: EventDetailsWrapper,
                    },
                  ],
                },
                {
                  path: "/market-dashboard/:id/channeldetails/:instanceId",
                  name: "Dashboard TO Channel Details",
                  meta: { label: "Channel Details" },
                  component: ChannelDetails,
                },
                {
                  path: "/market-dashboard/:id/channeldetails/:instanceId",
                  name: "Dashboard Channel Details",
                  meta: { label: "Channel Details" },
                  component: ChannelDetails,
                },
              ],
            },
            {
              path: "/channeldetails/:instanceId",
              name: "Channel Details",
              component: ChannelDetails,
              props: true,
            },
          ],
        },
        {
          path: "/portfolio",
          name: "Lists",
          component: Portfolio,
        },
        {
          path: "/events",
          name: "Events Wrapper",
          redirect: "/events",
          meta: { label: "Events" },
          component: Events,
          children: [
            {
              path: "/events",
              name: "Events",
              meta: { label: " " },
              component: EventListWrapper,
            },
            {
              path: "/events/channeldetails/:instanceId",
              name: "Events To Channel Details",
              meta: { label: "Channel Details" },
              component: ChannelDetails,
            },
            {
              path: "/events/market-dashboard/:id",
              name: "Events To Dashboard Wrapper",
              meta: { label: "Dashboard" },
              component: DashboardWrapper,
              redirect: "/events/market-dashboard/:id",
              children: [
                {
                  path: "/events/market-dashboard/:id",
                  name: "Events To Dashboard",
                  meta: { label: " " },
                  component: Dashboard,
                },
                {
                  path: "/events/market-dashboard/:id/event-details/:eventId",
                  name: "Events To Event Details via Dashboard",
                  meta: { label: "Event Details" },
                  component: EventDetailsWrapper,
                },
                {
                  path:
                    "/events/market-dashboard/:id/channeldetails/:instanceId",
                  name: "Events To Channel Details via Dashboard",
                  meta: { label: "Channel Details" },
                  component: ChannelDetails,
                },
              ],
            },
            {
              path: "/events/event-details/:eventId",
              name: "Event to Event Details Wrapper",
              meta: { label: "Event Details" },
              component: EventDetails,
              redirect: "/events/event-details/:eventId",
              children: [
                {
                  path: "/events/event-details/:eventId",
                  name: "Event to Event Details",
                  meta: { label: " " },
                  component: EventDetailsWrapper,
                },
                {
                  path:
                    "/events/event-details/:eventId/channeldetails/:instanceId",
                  name: "Event To Channel Details via Event Details",
                  meta: { label: "Channel Details" },
                  component: ChannelDetails,
                },
                {
                  path: "/events/event-details/:eventId/market-dashboard/:id",
                  name: "Events To Dashboard via Event Details Wrapper",
                  meta: { label: "Dashboard" },
                  component: DashboardWrapper,
                  redirect:
                    "/events/event-details/:eventId/market-dashboard/:id",
                  children: [
                    {
                      path:
                        "/events/event-details/:eventId/market-dashboard/:id",
                      name: "Events To Dashboard via Event Details",
                      meta: { label: " " },
                      component: Dashboard,
                    },
                    {
                      path:
                        "/events/event-details/:eventId/market-dashboard/:id/channeldetails/:instanceId",
                      name:
                        "Events To ChannelDetails via Event Details and Dashboard",
                      meta: { label: "Channel Details" },
                      component: ChannelDetails,
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          path: "/deliverables",
          name: "Deliverables",
          component: Deliverables,
          redirect: "/deliverables",
          children: [
            //{
            //path: '/deliverables/home',
            //name: '',
            //component: DeliverablesHome,
            // path: '/projectReport/channelVerification',
            // name: 'Channel Verification',
            // component: ChannelVerification,
            // redirect : '/projectReport/channelVerification',
            // children: [
            //   {
            //     path: '/projectReport/channelVerification',
            //     name: '',
            //     component: ChannelVerificationPage,
            //   },
            //   {
            //     path: '/projectReport/channelVerification/channeldetails/:instanceId',
            //     name: 'Project Report Channel Details',
            //     meta :{ label : 'Channel Details' },
            //     component: ChannelDetails,
            //   }
            // ]
            //},
            {
              path: "/deliverables",
              name: "",
              component: DeliverablesHome,
            },
            {
              path: "/deliverables/projectReport",
              name: "Project Report",
              component: ProjectReportWrapper,
              redirect: "/deliverables/projectReport",
              children: [
                {
                  path: "/deliverables/projectReport",
                  name: "",
                  component: ProjectReport,
                },
                {
                  name: "Project Report to Dashboard",
                  meta: { label: "Market Dashboard" },
                  path: "/deliverables/projectReport/dashboard/:id",
                  component: DashboardWrapper,
                  redirect: "/deliverables/projectReport/dashboard/:id",
                  children: [
                    {
                      path: "/deliverables/projectReport/dashboard/:id",
                      name: "",
                      component: Dashboard,
                    },
                  ],
                },
                {
                  name: "Project Report to Channel Verification",
                  meta: { label: "Channel Verification" },
                  path: "/deliverables/projectReport/channelVerification",
                  component: ChannelVerificationPage,
                  redirect: "/deliverables/projectReport/channelVerification",
                  children: [
                    {
                      path: "/deliverables/projectReport/channelVerification",
                      name: "",
                      component: ChannelVerificationPage,
                    },
                  ],
                },
              ],
            },
            {
              path: "/deliverables/sla-report",
              name: "SLA Uptime Report",
              component: SLAUptimeReport,
            },
            {
              path: "/deliverables/tam-report",
              name: "TAM Report",
              component: ProjectReportWrapper,
              redirect: "/deliverables/tam-report",
              children: [
                {
                  path: "/deliverables/tam-report",
                  name: "",
                  component: ProjectReport,
                },
                {
                  name: "TAM Report to Dashboard",
                  meta: { label: "Market Dashboard" },
                  path: "/deliverables/tam-report/dashboard/:id",
                  component: DashboardWrapper,
                  redirect: "/deliverables/tam-report/dashboard/:id",
                  children: [
                    {
                      path: "/deliverables/tam-report/dashboard/:id",
                      name: "",
                      component: Dashboard,
                    },
                  ],
                },
                {
                  name: "TAM Report to Channel Verification",
                  meta: { label: "Channel Verification" },
                  path: "/deliverables/tam-report/channelVerification",
                  component: ChannelVerificationPage,
                  redirect: "/deliverables/tam-report/channelVerification",
                  children: [
                    {
                      path: "/deliverables/tam-report/channelVerification",
                      name: "",
                      component: ChannelVerificationPage,
                    },
                  ],
                },
              ],
            },
          ],
        },
        // {
        //   path: '/projectReport',
        //   name: 'Project Report',
        //   component: ProjectReportWrapper,
        //   redirect: '/projectReport',
        //   children: [
        //     {
        //       path: '/projectReport/channelVerification',
        //       name: 'Channel Verification',
        //       component: ChannelVerificationPage,
        //     },
        //     {
        //       path: '/projectReport',
        //       name: '',
        //       component: ProjectReport,
        //     }]
        // },
        {
          path: "/ChangeCompany",
          name: "ChangeCompany",
          component: ChangeCompany,
        },
        {
          path: "/apiDoc",
          name: "API Documentation",
          component: APIDoc,
        },
        {
          path: "/unauthorized-access",
          name: "Unauthorize Access",
          component: UnauthorizedAccess,
        },
        {
          path: "*",
          name: "NotFound",
          component: Page404,
          redirect: "/home/dashboard"
        }
      ],
    },
    {
      path: "/register/:email",
      name: "Register",
      component: Register,
      meta: {
        analyticsIgnore: true,
      },
    },
  ];
}
